const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="bg-brand-primary py-16 border-t border-brand-gold/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <img
              src="https://customer-assets.emergentagent.com/job_rice-elegance/artifacts/xrreke3a_Untitled%20design.png"
              alt="Sartaj"
              className="h-20 w-auto object-contain"
            />
            <p className="font-body text-sm font-light text-brand-text-light/50 leading-relaxed max-w-xs">
              Purveyors of the world's finest basmati rice for over 25 years.
              Expertise, dedication, and one unwavering commitment to quality.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-xs uppercase tracking-[0.2em] text-brand-gold font-body font-semibold">
              Quick Links
            </h4>
            <div className="space-y-3">
              {["Our Story", "Our Range", "Rice Guide", "Testimonials"].map(
                (link) => (
                  <a
                    key={link}
                    href={`#${link.toLowerCase().replace(/\s/g, "-")}`}
                    className="block text-sm text-brand-text-light/50 hover:text-brand-gold transition-colors font-body"
                  >
                    {link}
                  </a>
                )
              )}
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="text-xs uppercase tracking-[0.2em] text-brand-gold font-body font-semibold">
              Contact
            </h4>
            <div className="space-y-3 font-body text-sm text-brand-text-light/50">
              <p>Brand owned by GS Pacific Marketing Aust Pty Ltd</p>
              <p>info@gspacific.com.au</p>
              <p>1800 934 114</p>
              <p>
                Unit 1, 2 Costello Pl
                <br />
                Seven Hills NSW 2147
              </p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-brand-gold/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-xs text-brand-text-light/30">
            &copy; {new Date().getFullYear()} Sartaj Rice. All rights reserved.
          </p>
          <div className="flex gap-8">
            {["Privacy Policy", "Terms of Service"].map((item) => (
              <span
                key={item}
                className="font-body text-xs text-brand-text-light/30 hover:text-brand-gold transition-colors cursor-pointer"
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
